<template>
  <EuiBlock   class="w-auto ml-0" title="Liste des deskRHDispatchId trouvés pour la période donnée">
    <EuiLoader :is-loading="loadNextLogs"/>
    <span id="searchBlock" style="position:absolute;top:0;height:400px;"/>
    <EuiHeading v-if="getterIsLoading" :level="2">En cours de chargement</EuiHeading>
    <EuiHeading :level="3" bold class="mt-2" v-else-if="getterLogs.messages.length === 0">
      Aucun résultat
    </EuiHeading>
    <div v-else class="flex">
      <timelineNavigation
          :content="mixinsGroupByDateLogs"
          :isActivateButtonMoreLogs="getterLogs.messages.length < getterLogs.total_results"
          @get-more-logs="loadNextResults"/>
      <div class="w-full listResultLogs"
           :class="{'listResultLogs__with_timelineFixed':this.getterTimelineFixed}">
        <EuiHeading :level="3" bold class="mt-2">
          Logs chargés: {{ getterLogs.messages.length }} / total: {{ getterLogs.total_results}}
        </EuiHeading>
        <EuiCard class="mt-4" v-for="(logs, date) in mixinsGroupByDateLogs" :key="date" style="">
            <span :id="date"/>
            <EuiBlock class="ml-0 pt-0" :title="`Logs du ${date}`" >
              <div class="p-2 pt-0" v-for="(log, index) in logs" :key="index">
                <EuiHeading :level="3">
                  Le {{ mixinsDateLocaleToDisplay(log.timestampLogs)}}
                </EuiHeading>
                <EuiBlock class="ml-0 pt-0" :title="`deskRHDispatchId: ${log.deskRHDispatchId}`">
                  <EuiHeading :level="4" class="mb-3">
                    <div class="mr-auto">Serveur hostname: {{ log.host }}</div>
                    <div>Serveur IP: {{ log.source }}</div>
                  </EuiHeading>
                  <EuiStepper horizontal>
                    <EuiStepperItem title="Initialisation"
                                    :error="log.has_error_init"
                                    subtitle="Initialisation du dispatch"/>
                    <EuiStepperItem :error="log.has_error_parse"
                                    :class="{'-perror': log.has_error_init}"
                                    title="Découpage des fichiers"
                                    :subtitle="`Nombre de page = ${log.nb_total_pages}`"/>
                    <EuiStepperItem :warning="log.has_ignored_file"
                                    title="Fichier ignoré"
                                    :class="{'-perror': log.has_error_parse}"
                                    :subtitle="ignoredFile(log)"/>
                    <EuiStepperItem :error="log.has_error_signature"
                                    title="Signature"
                                    :class="{'-pwarning': log.has_ignored_file}"
                                    />
                    <EuiStepperItem :error="log.has_error_response"
                                    title="Réponse"
                                    :class="{'-perror': log.has_error_signature}"

                    />
                  </EuiStepper>
                  <div v-if="showTrace === true" class="mt-1">
                    <traceArea
                        v-if="log.status_response"
                        title="Réponse"
                        :copyable="false"
                        :rows="2"
                        :message="log.status_response"
                        :error='log.status_response.includes(`"status":"ko"`)'/>
                    <traceArea
                        :id="log._id"
                        :rows="10"
                        :message="log.message"
                        :error="log.has_error"/>
                  </div>
                </EuiBlock>
              </div>
            </EuiBlock>
        </EuiCard>
      </div>
    </div>
    <intersection-observer
        v-if="getterLogs.messages.length < getterLogs.total_results"
        sentinal-name="infiniteScrollSentinal"
        @on-intersection-element="loadNextResults"
        :timer=5000
        style="position:absolute;bottom:0px;height:500px;"/>
  </EuiBlock>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import timelineNavigation from '@/components/logs/timelineNavigation.vue';
import traceArea from '@/components/logs/traceArea.vue';
import IntersectionObserver from '@/observer/intersectionObserver.vue';
import groupBy from '@/mixins/groupBy';
import dates from '@/mixins/dates';

/*
This component displays the logs result only for the webDriver service
 */
export default {
  name: 'components.logs.webdriver',
  mixins: [groupBy, dates],
  components: {
    timelineNavigation,
    IntersectionObserver,
    traceArea,
  },
  props: {
    showTrace: {
      type: Boolean,
      default: false,
    },
    loadNextLogs: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isTimelineFixed: false,
    };
  },
  watch: {
    isTimelineFixed(value) {
      this.storeSetTimelineFixed(value);
    },
    getterLogs() {
      this.initObserver();
    },
  },
  computed: {
    ...mapGetters({
      getterLogs: 'logs/result',
      getterTimelineFixed: 'application/timelineFixed',
      getterIsNavigationMini: 'application/isMiniVariant',
      getterIsLaunch: 'application/isLaunch',
      getterIsLoading: 'application/isLoading',
    }),
  },
  methods: {
    ...mapActions({
      storeSetTimelineFixed: 'application/setTimelineFixed',
    }),
    initObserver() {
      if (this.getterIsLaunch && this.getterLogs.messages.length > 0) {
        const sentinal = document.getElementById('searchBlock');
        const handler = (entries) => {
          if (entries[0].isIntersecting) {
            this.isTimelineFixed = false;
          } else {
            this.isTimelineFixed = true;
          }
        };
        const observer = new window.IntersectionObserver(handler, {
          threshold: 0,
        });
        observer.observe(sentinal);
      }
    },
    loadNextResults() {
      this.$emit('load-next-result');
    },
    ignoredFile(log) {
      let ignored;
      if (!log.has_ignored_file) {
        ignored = 'Aucun fichier ignoré';
      } else {
        ignored = "Présence d'au moins un fichier ignoré";
      }
      return ignored;
    },
  },
};
</script>
